import React from 'react'
import './TabSegmentButtons.component.css'
import SegmentButtons, { ISegmentButtons } from '../SegmentButtons.component'

export const TabSegmentButtons: React.FC<ISegmentButtons> = (props: ISegmentButtons) => {
  const { className, ...remainingProps } = props
  return <SegmentButtons className={className + ' tabs-segmented-group'} {...remainingProps} />
}
